import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.scss'
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NewReleaseIcon from '@material-ui/icons/NewReleasesRounded';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import ManualAddressChangeRecommendationImage
    from "../../../../../resources/images/release-notes-v2-9-0/ManualAddressChangeRecommendation.png";
import ManualAddressChangeDialogImage
    from "../../../../../resources/images/release-notes-v2-9-0/ManualAddressChangeDialog.png";
import WavingHand from "../../../../../resources/images/WavingHand.png";
import Skeleton from "@material-ui/lab/Skeleton";

const latestReleaseNotesVersion = "2.21.1";
const isReleaseNotesDialogEnabled = false;

export {latestReleaseNotesVersion, isReleaseNotesDialogEnabled};

export default class NewReleaseDialog extends PureComponent {
    constructor(props) {
        super(props);
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    render() {
        return (
            <div>
                <Dialog
                    scroll={'paper'}
                    className="new-release-dialog"
                    open={this.props.open}
                    onClose={this.handleClose.bind(this)}
                    fullWidth={true}
                    maxWidth={'md'}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">
                        <div className="new-release-dialog-title-content">
                            {
                                this.props.open ?
                                    <div className="skeleton-container">
                                        <Skeleton animation="wave"/>
                                    </div>
                                    :
                                    null
                            }
                            <NewReleaseIcon style={{"fontSize": "32px"}}/>&nbsp;עדכון גרסה 2.21.0 – שמירת
                            שינויי כתובות לתמיד
                        </div>
                    </DialogTitle>
                    <DialogContent className="release-notes-dialog-content" dividers={true}>
                        <div className="release-notes-content">
                            <div className="hello-shipit-users">
                                <span style={{fontSize: "1.5em"}}>שלום משתמשי Shipit</span>
                                &nbsp;
                                &nbsp;
                                <img src={WavingHand} className="waving-hand-image" alt="Shipit"/>
                            </div>
                            <br/>
                            מכירים את זה שכתובת לא נכונה חוזרת על עצמה שוב ושוב?<br/>
                            מעכשיו אפשר לשמור את השינוי עבור ההזמנות הבאות, כך שבפעם הבאה, הכתובת תיכנס בדיוק כמו שאתם רוצים,
                            בלי לשנות אותה באופן ידני.
                            <br/>
                            <br/>
                            ניתן להפעיל את היכולת הזו בשתי דרכים:
                            <div className="release-features">
                                <Accordion className="release-feature" defaultExpanded={true}
                                           style={{
                                               overflow: "hidden"
                                           }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        1. המערכת מזהה שינוי שחוזר על עצמו ומציעה לשמור את השינוי לתמיד
                                    </AccordionSummary>
                                    <AccordionDetails className="release-feature-details">
                                        <img src={ManualAddressChangeRecommendationImage}
                                             style={{
                                                 height: "18em",
                                                 margin: "-2em"
                                             }}/>
                                        <div style={{zIndex: 1000}}>
* כרגע, המערכת מוגדרת להציע את השמירה במידה והשינוי קרה ב2 הזמנות זהות ומעלה.
                                            <br/>
                                            &nbsp;&nbsp;&nbsp;במידה ותרצו שהמערכת תציע במצבים שונים, לדוגמא, בכל שינוי, או רק ב3 שינויים ומעלה,
                                            צרו איתנו קשר.
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion className="release-feature" defaultExpanded={true}
                                           style={{
                                               overflow: "hidden"
                                           }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        2. חלונית כתובות
                                    </AccordionSummary>
                                    <AccordionDetails className="release-feature-details">
                                        <div style={{zIndex: 1000}}>
                                            ניתן לפתוח את החלונית בעזרת הכפתור ״כתובות״ שנמצא בשורת המשימות של Shipit
                                        </div>
                                        <br/>
                                        <img src={ManualAddressChangeDialogImage}
                                             style={{
                                                 height: "37em",
                                                 margin: "-3.5em -3.5em -2.8em -3.5em"
                                             }}/>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                        <div className="dialog-actions">
                            <IconButton className="close-button"
                                        onClick={this.handleClose.bind(this)}>
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}